(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery */

	let lazyLoadInstance;
	let previousWindowHeight = 0;





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".lazy",
		});
	}





// Set Variables in JS
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
	}

	function set100VHVariable() {
		const windowHeight = window.innerHeight;
		const windowOuterHeight = window.outerHeight;
		if (windowOuterHeight !== previousWindowHeight) {
			previousWindowHeight = windowOuterHeight;
			document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
		}
	}





// Active Menu on Scroll
// -----------------------------------------------------------------------------

	function activeMenuOnScroll() {
		const windowTop = $(window).scrollTop();

		$(".js-scroll-section").each(function () {
			const $element = $(this);
			let elementTop = $element.offset().top;
			elementTop += -($(".js-dates").outerHeight() + parseInt($(".js-dates").css("margin-top"), 10) + 1);
			const elementHeight = $element.outerHeight();
			const elementId = $element.attr("id");

			if (windowTop >= elementTop && windowTop < elementTop + elementHeight) {
				$(`.js-scroll-link[href="#${elementId}"]`).addClass("is-active");
			} else {
				$(`.js-scroll-link[href="#${elementId}"]`).removeClass("is-active");
			}
		});
	};





// Scroll to Section
// -----------------------------------------------------------------------------

	function scrollToSection() {
		$(".js-scroll-link").on("click", function (event) {
			event.preventDefault();

			const $element = $(this);
			const elementHref = $element.attr("href");
			let elementOffset = $(elementHref).offset().top;
			elementOffset += -($(".js-dates").outerHeight() + parseInt($(".js-dates").css("margin-top"), 10));

			$("html, body").animate({
				scrollTop: elementOffset,
			}, 500);
		});
	}




// Credits on Click
// -----------------------------------------------------------------------------

	function creditsOnClick() {
		$(".js-credits").on("click", function (event) {
			event.preventDefault();
			$(".js-hidden").slideToggle();
		});
	}





// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		initLazyLoad();
		setScrollbarWidthVariable();
		set100VHVariable();
		activeMenuOnScroll();
		scrollToSection();
		creditsOnClick()
	});

	$(window).on("scroll", () => {
		activeMenuOnScroll();
	});

	$(window).on("resize", () => {
		lazyLoadInstance.update();
		setScrollbarWidthVariable();
		set100VHVariable();
	});

}(jQuery));
